import { mockData } from "./Mock";
import { ProductAudit } from "../../models/ProductAudit";

const imageMock = "https://pub-img-wfile.yuanling.com/3/33/45/6/49/5eafce2266281a71a0f693d1483cf67851d1181f2de225f97a00a212.png";
const mockCandidates: ProductAudit[] = [
    {
        draftId: 1001,
        productName: "高级UI设计服务",
        sellerId: 101,
        sellerNickname: "设计大师",
        sellerLevel: 3,
        categoryId: 201,
        firstCategoryName: "设计服务",
        secondCategoryName: "UI设计",
        headImages: [
            imageMock,
            imageMock
        ],
        detailImages: [
            imageMock,
            imageMock,
            imageMock
        ],
        standardDescription: "提供专业的UI设计服务，包含3次修改",
        trialDescription: "提供1个页面的UI设计，包含1次修改",
        trialEnabled: true,
        standardPrice: 1999,
        trialPrice: 299,
        draftStatus: 2,
        refuseReason: "",
        updateTime: "2024-03-20 14:30:00"
    },
    {
        draftId: 1002,
        productName: "Logo设计服务",
        sellerId: 102,
        sellerNickname: "创意工作室",
        sellerLevel: 4,
        categoryId: 202,
        firstCategoryName: "设计服务",
        secondCategoryName: "Logo设计",
        headImages: [
            imageMock,
            imageMock
        ],
        detailImages: [
            imageMock,
            imageMock
        ],
        standardDescription: "专业Logo设计，提供源文件",
        trialDescription: "提供2个Logo方案",
        trialEnabled: true,
        standardPrice: 2999,
        trialPrice: 499,
        draftStatus: 2,
        refuseReason: "",
        updateTime: "2024-03-20 15:00:00"
    }
];

const mockProcessed: ProductAudit[] = [
    {
        draftId: 1003,
        productName: "网站开发服务",
        sellerId: 103,
        sellerNickname: "代码工匠",
        sellerLevel: 5,
        categoryId: 301,
        firstCategoryName: "开发服务",
        secondCategoryName: "网站开发",
        headImages: [
            imageMock,
            imageMock
        ],
        detailImages: [
            imageMock,
            imageMock
        ],
        standardDescription: "全栈网站开发服务",
        trialDescription: "单页面开发服务",
        trialEnabled: true,
        standardPrice: 9999,
        trialPrice: 1999,
        draftStatus: 0,
        refuseReason: "需要补充技术架构说明",
        updateTime: "2024-03-19 10:00:00"
    }
];

mockData.set("audit_candidates", mockCandidates);
mockData.set("audit_processed", mockProcessed); 